import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LifeActComponent } from './lifeAct.component';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { ButtonModule } from '@app/components/button/button.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { PlTextareaModule } from '@app/components/pl-textarea/pl-textarea.module';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { PlInputModule } from '@app/components/pl-input/pl-input.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ModalAddToCalendarModule } from '@app/components/lifeAct/modalAddToCalendar/modalAddToCalendar.module';
import { PlSlicePipeModule } from '@shared/pipes/plSlice/plSlice.pipe.module';

@NgModule({
  imports: [
    ButtonModule,
    CommonModule,
    FormsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatNativeDateModule,
    PlIconModule,
    PlInputModule,
    PlTextareaModule,
    TranslateModule,
    ModalAddToCalendarModule,
    PlSlicePipeModule,
  ],
  declarations: [LifeActComponent],
  exports: [LifeActComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LifeActModule {}
